import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const autosuggestViewAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.AutosuggestView, Permission.StoreConfigsView],
  restrictedBannersAllowed: true,
}

export const autosuggestLinksSingleScopeNavAccessControl: DomainAccessControlConfig = {
  ...autosuggestViewAccessControl,
  maxICPlatformVersionExclusive: ICPlatformVersion.r2026_11_0,
}

export const autosuggestModifyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.AutosuggestModify],
  restrictedBannersAllowed: true,
}
